import { createScopedDescriptor } from 'quartz/globalState/api';
import { getBuildTimePropertyNames } from 'quartz/globalState/initialize';

// Properties initialized in quartz/globalState/initialize.ts

export const CURRENT_PACKAGE_NAME = createScopedDescriptor(getBuildTimePropertyNames().currentPackageName, 'BROWSING_CONTEXT');
export const CURRENT_PACKAGE_VERSION = createScopedDescriptor(getBuildTimePropertyNames().currentPackageVersion, 'BROWSING_CONTEXT');
export const ROOT_PACKAGE_NAME = createScopedDescriptor(getBuildTimePropertyNames().rootPackageName, 'TAB');
export const ROOT_PACKAGE_VERSION = createScopedDescriptor(getBuildTimePropertyNames().rootPackageVersion, 'TAB');
export const GRANITE_ENABLED_DESCRIPTOR = createScopedDescriptor('graniteEnabled', 'EXECUTION_CONTEXT');
export const GRANITE_REMOTE_APP_DESCRIPTOR = createScopedDescriptor('graniteRemoteApp', 'EXECUTION_CONTEXT');
export const APP_START_TIME_DESCRIPTOR = createScopedDescriptor('appStartTimeMs', 'BROWSING_CONTEXT');